import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { jsonLdBlocksForRoutePath } from '../../config/routeJsonLd';
import { getRouteMetaForPathname } from '../../config/routeMeta';
import { DocumentMeta } from './DocumentMeta';

/** Applies routeMeta to DocumentMeta on client-side navigation. */
export function PublicRouteDocumentMeta() {
  const { pathname } = useLocation();
  const meta = getRouteMetaForPathname(pathname);
  const jsonLd = useMemo(
    () => (meta ? jsonLdBlocksForRoutePath(meta.path) : null),
    [meta?.path],
  );
  if (!meta) {
    return null;
  }
  const robotsNoIndex = Boolean(meta.robotsNoIndex);
  return (
    <DocumentMeta
      title={meta.title}
      description={meta.description}
      canonicalPath={robotsNoIndex ? null : meta.path}
      robotsNoIndex={robotsNoIndex}
      jsonLd={jsonLd}
    />
  );
}
